import template from './accounts-details-high-yield-hsa.html';
import { ParticipantOpportunitiesService } from "../../Http/SmartAccount/OpportunitiesService";
import { AccountsService } from "../../Http/Accounts/AccountsService";

(function ($, ko) {

    function highYieldHsaModel(params, updateHeight, template) {
        let model = params.model;
        this.model = model;
        this.isTraditional = ko.observable(false);

        this.accountId = parseInt($.cdh.helper.urlParam('accountId'));
        this.options = parseInt($.cdh.helper.urlParam('options'));
        this.extendedDetails = new $.cdh.get.accounts.detailsHsa(this.accountId);
        this.stableProviders = new $.cdh.get.accounts.stableProvider(this.accountId);
        this.disclosures = new $.cdh.get.accounts.disclosures(this.accountId);
        this.highYieldOptIn = $.cdh.helper.urlParam('highYieldOptIn') === "true";
        const urlParams = {
            opportunityId: $.cdh.helper.urlParam('opportunityId'),
        };
        this.isHyOptIn = ko.observable(this.highYieldOptIn);
        this.isHyOptInSelected = ko.observable(false);
        this.updateAccountRequest = new $.cdh.post.accounts.updateHighYieldStatus();
        this.hsahyagreement = ko.observable(false);
        this.redirectUrl = $.cdh.routes.predefined.accounts.detailsHsa + '?accountId=' + this.accountId;
        this.isSwitched = ko.observable(false);

        this.canSignup = ko.pureComputed(function () {
            return !this.updateAccountRequest.isLoading() && this.isSwitched() && (this.isHyOptInSelected() ? this.hsahyagreement() : true);
        }, this);

        this.showAccountsSelector = ko.observable(false);
        this.showPageNotFoundError = ko.observable(false);
        this.sortedHSAAccounts = ko.observableArray([]); // Holds list of eligible HSA accounts
        this.selectedAccount = ko.observable(); // Holds user-selected account

        $(".error-box.hide-PageNotFound-before").removeClass("hide-PageNotFound-before");

        if (!this.accountId) {
            this.accountService = new AccountsService();
            this.accountService.getListHsaAsync($.cdh.enums.planYear.all).then(function (accounts) {
                if (accounts && accounts.length > 0) {
                    const highYieldAccounts = accounts
                        .filter(ac => ac.HighYieldEligibility && ac.HighYieldOptIn === true)
                        .sort((a, b) => a.Priority - b.Priority);

                    if (highYieldAccounts.length > 1) {
                        this.sortedHSAAccounts(highYieldAccounts);
                        this.showAccountsSelector(true);
                    } else if (highYieldAccounts.length === 1) {
                        this.setSelectedAccount(highYieldAccounts[0]);
                    } else {
                        this.showPageNotFoundError(true);
                    }
                }
                else {
                    this.showPageNotFoundError(true);
                }
            }.bind(this));

            this.setSelectedAccount = function (account) {
                if (!account) return;
                document.location.href = $.cdh.routes.predefined.accounts.detailsHYHsa + '?accountId=' + account.AccountId + '&highYieldOptIn=' + account.HighYieldOptIn + '&options=' + account.AccountTypeOptions;
            }.bind(this);

            // Update when dropdown changes
            this.selectedAccount.subscribe(this.setSelectedAccount);
        }

        this.updateAccount = function () {
            this.updateAccountRequest.load({
                id: this.accountId,
                options: this.options,
                highYieldOptIn: this.isHyOptIn()
            }).done(function () {
                if (urlParams.opportunityId) {
                    let opportunitiesService = new ParticipantOpportunitiesService();
                    opportunitiesService.hideAsync(urlParams.opportunityId).then(() => {
                        window.location.href = this.redirectUrl;
                    });
                }
                else {
                    window.location.href = this.redirectUrl;
                }
            }.bind(this));
        };

        this.stableProvidersData = ko.observableArray([]);
        this.disclosuresData = ko.observableArray([]);

        if (this.accountId) {
            var extendedDetailsPromise = this.extendedDetails.load();
            var stableProvidersPromise = this.stableProviders.load().done(function (data) {
                this.stableProvidersData(data);
            }.bind(this));
            var disclosuresPromise = this.disclosures.load().done(function (data) {
                this.disclosuresData(data || []);
            }.bind(this));

            $.when(extendedDetailsPromise, stableProvidersPromise, disclosuresPromise).done(function () {
                recalcWidgetsHeights();
            });
        }
    }

    self.selectInterestRates = function (self, status) {

        self.isSwitched(!(self.highYieldOptIn === status));

        self.isHyOptIn(status);

        if (self.isSwitched()) {
            self.isHyOptInSelected(status);
        }
    }


    ko.components.register('accounts-details-high-yield-hsa',
        {
            template: template,
            viewModel: {
                createViewModel: function (params, componentInfo) {
                    var updateHeight = updateContainerHeight(componentInfo.element);
                    return new highYieldHsaModel(updateHeight, params.template);
                }
            }
        });
})(jQuery, ko);